interface Props {
  children: React.ReactElement | React.ReactElement[];
}

export const Container = ({ children }: Props) => (
  <div className="mx-auto flex min-h-screen w-screen flex-col bg-white">{children}</div>
);
